
import { SetupContext } from 'vue'
import { numberFormatAddComma } from '@/utils/commonMethods'

export default {
  name: 'HomeEasySearch',

  props: {
    count: {
      type: Number,
      default: 0
    }
  },

  setup(props: any, context: SetupContext) {
    const open = (type: string) => {
      context.emit('click-btn', type)
    }

    return {
      open,
      numberFormatAddComma
    }
  }
}
